export default {
	add_new_product: "Add a new product",
	brand: "Brand",
	detail_sold_products: "Details of the product sold",
	for_more_than_one_product_click_on_the_add_new_product_button_and_fill_in_each_one: "For more than one product, click on the \"Add a new product\" button.",
	insert_more_sales: "Report more sales",
	insert_new_sale: "Report a new sale",
	insert_sale: "Report sales",
	invoice_number: "Invoice number",
	no_retailers_found: "No retailers found",
	no_stores_found: "No stores found",
	observation: "Observation",
	processor: "Processor",
	product_type: "Product type",
	products: "Products",
	quantity_points: "Points quantity",
	quantity: "Quantity",
	remove_product: "Remove product",
	retailer: "Retailer",
	sale_date: "Sale Date",
	send_invoices_to_claim_your_points: "Send invoices to claim your points",
	sku: "SKU",
	specify_below_the_product_sold_eligible_that_appears_on_the_invoice_sent: "Specify below the eligible product sold that is informed in the invoice.",
	store: "Store",
	take_a_picture: "Take a picture",
	the_note_number_has_already_been_sent_by_the_user_before: "The note number has already been sent by the user before",
	tip: "Tip",
	upload_invoice: "Upload an invoice",
	your_sale_has_been_successfully_registered_and_your_points_were_credited_this_points_are_liable_to_be_auditable_before_your_prize_redeem_is_confirmed: "Your sale has been successfully registered and your points were credited. These points are liable to be audited before your prize redemption is confirmed."
}